import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import sortBy from 'lodash/sortBy';

import { Typo } from 'tmt-ui-kit';
// import GoogleMaps from './GoogleMaps';
import MeetingPoint from './MeetingPoint';

const MeetingPointsContainer = styled.div`
`;

const MeetingPointsHeading = styled(Typo.HeaderTwo)`
  text-transform: capitalize;
  margin: 0px 0px 16px;
`;

const MeetingPointText = styled(Typo.Paragraph)`
  text-transform: capitalize;
  &:last-child {
    padding-bottom: 16px !important;
  }
`;

const MeetingPointList = props => {
  return props.points.map(p => <MeetingPointText key={p}>{p}</MeetingPointText>);
};

MeetingPointList.propTypes = {
  points: PropTypes.array
};

const MeetingPoints = props => {
  const { trip } = props;
  const { meeting_points: meetingPoints } = trip;
  const hasCustomLocations = trip.custom_locations && trip.custom_locations.length > 0;
  const hotel = meetingPoints.filter(mp => mp.type === 'Hotel Pickup');
  const bts = sortBy(meetingPoints.filter(mp => mp.type === 'BTS Station'), 'name');
  const mrt = sortBy(meetingPoints.filter(mp => mp.type === 'MRT Station'), 'name');
  const arl = sortBy(meetingPoints.filter(mp => mp.type === 'Airport Rail Link Station'), 'name');
  const railway = sortBy(meetingPoints.filter(mp => mp.type === 'Railway Station'), 'name');
  const airport = sortBy(meetingPoints.filter(mp => mp.type === 'Airport'), 'name');
  const bus = sortBy(meetingPoints.filter(mp => mp.type === 'Bus Terminal'), 'name');
  return (
    <MeetingPointsContainer>
      <MeetingPointsHeading>{pluralize('Meeting Point', meetingPoints.length)}</MeetingPointsHeading>
      {hotel.length > 0 && <MeetingPoint points={hotel} type="hotel" />}
      {airport.length > 0 && <MeetingPoint points={airport} type="airplane" />}
      {arl.length > 0 && <MeetingPoint points={arl} type="arl" />}
      {bts.length > 0 && <MeetingPoint points={bts} type="bts" />}
      {mrt.length > 0 && <MeetingPoint points={mrt} type="mrt" />}
      {bus.length > 0 && <MeetingPoint points={bus} type="bus" />}
      {railway.length > 0 && <MeetingPoint points={railway} type="train" />}
      {hasCustomLocations && <MeetingPoint points={trip.custom_locations} type="custom" />}
    </MeetingPointsContainer>
  );
};

// MeetingPoints.defaultProps = {
//   renderMap: (props) => (<GoogleMaps {...props} />)
// };

MeetingPoints.propTypes = {
  trip: PropTypes.object
};

export default MeetingPoints;
